import {
  LabEquipment as _LabEquipment,
  LabEquipmentMaintenance as _LabEquipmentMaintenance,
} from '@team-milva/lab-models/labEquipment'
import type {
  ILabEquipment as _ILabEquipment,
  ILabEquipmentMaintenance as _ILabEquipmentMaintenance,
} from '@team-milva/lab-models/labEquipment'

export class LabEquipment extends _LabEquipment {
  constructor(params: Partial<_ILabEquipment> = {}) {
    super(params)
  }
}

export class LabEquipmentMaintenance extends _LabEquipmentMaintenance {
  constructor(params: Partial<_ILabEquipmentMaintenance> = {}) {
    super(params)
  }
}

